module.exports = __webpack_public_path__ + "img/header_dsk@2x.8478a44.jpg";